import React from 'react'
import { LinearProgress, Stack, Table, TableBody, TableContainer, Typography } from '@mui/material'
import { Link } from 'react-router'
import { IssueTypeText } from '../../../../components/entities/IssueType'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { CompanyEventRow } from './CompanyEventRow'
import IssueApi from '../../../../api/IssueApi'
import { useAppLocale } from '../../../../i18n/localeUtils'
import { IssueEntity } from 'types/IssueEntity'
import { IsinEntity } from '@finance-lab/utils/types'

async function addIsinToIssue(issue: { id: string }, isin: IsinEntity) {
    const issueApi = new IssueApi()

    if (isin.instrumentType === 'warrants') return null

    if (!issue || !isin) {
        console.error(`addIsinToIssue: Missing ${issue ? '' : 'issue'} ${isin ? '' : 'isin'}`)
        return null
    }
    const updateObject = isin.instrumentType === 'unit' ? { isinUnits: isin.isin } : { isinRights: isin.isin }
    const addedIsinToIssue = await issueApi.patchFields(issue.id, updateObject)
    return addedIsinToIssue
}

export const CompanyIssues = ({
    issues,
    selectedIsin,
    setSelectedIsin,
    onArchiveIsin,
}: {
    issues: Array<IssueEntity> | null
    selectedIsin: IsinEntity | null
    setSelectedIsin: (i: IsinEntity | null) => void
    onArchiveIsin: (i: IsinEntity, archive?: boolean) => Promise<void>
}) => {
    const { language } = useAppLocale()

    if (!issues) return <LinearProgress />

    if (issues.length === 0) {
        return <Typography variant='body1'>Inga emissioner hittades</Typography>
    }

    return (
        <TableContainer>
            <Table>
                <TableBody>
                    {issues.map((issue) => (
                        <CompanyEventRow
                            key={issue.id}
                            event={issue}
                            eventType='issue'
                            selectedIsin={selectedIsin}
                            setSelectedIsin={setSelectedIsin}
                            addIsinToEntity={addIsinToIssue}
                            onArchiveIsin={onArchiveIsin}
                        >
                            <Stack>
                                <Link to={`/admin/issues/${issue.id}`} target='_blank'>
                                    {issue.shareName} -{' '}
                                    {issue.subEndDate
                                        ? formatDateYYYYMMDD(issue.subEndDate, { locale: language })
                                        : formatDateYYYYMMDD(issue.publicationDate, { locale: language })}
                                </Link>
                                <i>
                                    <IssueTypeText issueType={issue.type} />
                                </i>
                            </Stack>
                        </CompanyEventRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
